// Tipi di domanda dei Form pubblici (stessa lista di backend/src/modules/form/form.campi.ts).
export const TIPI = [
  { tipo: 'TESTO_BREVE',     label: 'Risposta breve' },
  { tipo: 'TESTO_LUNGO',     label: 'Paragrafo' },
  { tipo: 'SCELTA_SINGOLA',  label: 'Scelta singola (una risposta)' },
  { tipo: 'SCELTA_MULTIPLA', label: 'Scelta multipla (più risposte)' },
  { tipo: 'ELENCO',          label: 'Menu a tendina' },
  { tipo: 'SI_NO',           label: 'Sì / No' },
  { tipo: 'DATA',            label: 'Data' },
  { tipo: 'NUMERO',          label: 'Numero' },
  { tipo: 'EMAIL',           label: 'Email' },
  { tipo: 'TELEFONO',        label: 'Telefono' },
  { tipo: 'CODICE_FISCALE',  label: 'Codice fiscale' },
  { tipo: 'ALLEGATO',        label: 'Caricamento file (o foto)' },
  { tipo: 'FIRMA',           label: 'Firma (col dito o col nome)' },
  { tipo: 'VALUTAZIONE',     label: 'Valutazione (stelle o faccine)' },
  { tipo: 'CONSENSO',        label: 'Consenso (da spuntare)' },
  { tipo: 'DOCUMENTO',       label: 'Regolamento da sottoscrivere' },
  { tipo: 'INFO',            label: 'Testo da leggere (nessuna risposta)' },
  { tipo: 'SEZIONE',         label: 'Titolo e testo' },
];
export const etichettaTipo = (t) => TIPI.find(x => x.tipo === t)?.label || t;
export const CON_OPZIONI = ['SCELTA_SINGOLA', 'SCELTA_MULTIPLA', 'ELENCO'];
export const CON_FOTO = ['SCELTA_SINGOLA', 'SCELTA_MULTIPLA'];
// tipi che non chiedono niente a chi compila
export const SENZA_RISPOSTA = ['SEZIONE', 'INFO'];
// Firma: come si firma (lo sceglie chi prepara il form)
export const MODI_FIRMA = [
  { modo: 'dito',   label: 'Solo col dito',               aiuto: 'Firma disegnata nel riquadro, col dito da telefono o col mouse.' },
  { modo: 'nome',   label: 'Spunta + nome e cognome',     aiuto: 'Scrive nome e cognome e spunta "il nome scritto vale come mia firma".' },
  { modo: 'scelta', label: 'A scelta di chi compila',     aiuto: 'Due linguette: firma col dito oppure scrive il nome.' },
];
export const ACCETTA_DEFAULT = 'Ho letto e accetto il regolamento';
// Valutazione: 5 livelli, dal peggiore al migliore
export const FACCINE = [['😞', 'Male'], ['🙁', 'Così così'], ['😐', 'Normale'], ['🙂', 'Bene'], ['😄', 'Benissimo']];
export const testoValutazione = (v, stile) => (!v ? '' : stile === 'faccine' ? `${FACCINE[v - 1]?.[0] || ''} ${FACCINE[v - 1]?.[1] || v}` : `${'★'.repeat(v)}${'☆'.repeat(5 - v)} (${v}/5)`);

// Dati della scheda anagrafica che un campo può alimentare, con il tipo di domanda richiesto.
export const ANAGRAFICA = [
  { chiave: 'cognome',        label: 'Cognome',        tipo: 'TESTO_BREVE' },
  { chiave: 'nome',           label: 'Nome',           tipo: 'TESTO_BREVE' },
  { chiave: 'codice_fiscale', label: 'Codice fiscale', tipo: 'CODICE_FISCALE' },
  { chiave: 'email',          label: 'Email',          tipo: 'EMAIL' },
  { chiave: 'telefono',       label: 'Telefono',       tipo: 'TELEFONO' },
  { chiave: 'data_nascita',   label: 'Data di nascita', tipo: 'DATA' },
  { chiave: 'luogo_nascita',  label: 'Luogo di nascita', tipo: 'TESTO_BREVE' },
];

// Domande che descrivono la persona (controllo del CF): collegate a mano, altrimenti riconosciute dal titolo
// se ce n'è una sola. Stessa logica di backend/src/modules/form/form.campi.ts (campiPersona).
const ALTRUI = /genitor|tutor|madre|padre|mamma|papa|compagn|partner|squadra|referente|accompagn|emergenza/;
const titolo = (c) => (c.etichetta || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[*:?.]/g, '').replace(/\s+/g, ' ').trim();
const DI = "( (dell[' ]?)?(atleta|partecipante|iscritt[oa]|ragazz[oa]|bambin[oa]|figli[oa]|giocator[ei]))?";
const RICONOSCI = {
  nome: (c) => c.tipo === 'TESTO_BREVE' && new RegExp(`^nome${DI}$`).test(titolo(c)),
  cognome: (c) => c.tipo === 'TESTO_BREVE' && new RegExp(`^cognome${DI}$`).test(titolo(c)),
  data_nascita: (c) => c.tipo === 'DATA' && /nascita|nat[oa] il/.test(titolo(c)) && !ALTRUI.test(titolo(c)),
  luogo_nascita: (c) => c.tipo === 'TESTO_BREVE' && (/(luogo|comune|citta|paese|stato|localita).*nascita/.test(titolo(c)) || /^nat[oa] a\b/.test(titolo(c))) && !ALTRUI.test(titolo(c)),
  codice_fiscale: (c) => c.tipo === 'CODICE_FISCALE' && !ALTRUI.test(titolo(c)),
};
// { nome: { id, auto }, ... }
export const campiPersona = (campi = []) => {
  const out = {};
  for (const k of Object.keys(RICONOSCI)) {
    const esplicito = campi.find(c => c.anagrafica === k);
    if (esplicito) { out[k] = { id: esplicito.id, auto: false }; continue; }
    const cand = campi.filter(c => !c.anagrafica && RICONOSCI[k](c));
    if (cand.length === 1) out[k] = { id: cand[0].id, auto: true };
  }
  return out;
};
export const NOMI_PERSONA = { nome: 'Nome', cognome: 'Cognome', data_nascita: 'Data di nascita', luogo_nascita: 'Luogo di nascita', codice_fiscale: 'Codice fiscale' };

export const nuovoId = () => Math.random().toString(36).slice(2, 10);

export const nuovoCampo = (tipo) => ({
  id: nuovoId(), tipo, etichetta: tipo === 'SEZIONE' ? 'Nuova sezione' : '', descrizione: '',
  obbligatorio: tipo === 'CONSENSO',
  ...(CON_OPZIONI.includes(tipo) ? { opzioni: ['Opzione 1'] } : {}),
  ...(tipo === 'ALLEGATO' ? { max_file: 1, max_mb: 5 } : {}),
  ...(tipo === 'NUMERO' ? { min: null, max: null } : {}),
  ...(tipo === 'VALUTAZIONE' ? { stile: 'stelle' } : {}),
  ...(tipo === 'FIRMA' ? { modo_firma: 'dito' } : {}),
  ...(tipo === 'DOCUMENTO' ? { etichetta: 'Regolamento', obbligatorio: true, testo_doc: '', pagine_doc: [], testo_accetta: ACCETTA_DEFAULT, leggi_tutto: true } : {}),
  ...(tipo === 'INFO' ? { etichetta: 'Da leggere', testo_doc: '', pagine_doc: [] } : {}),
});

// Cambio di tipo di una domanda già scritta: restano testo, aiuto, obbligatorietà e (tra tipi a scelta) le opzioni;
// le impostazioni del tipo vecchio che il nuovo non usa spariscono, quelle del nuovo partono dai valori di base.
export const convertiTipo = (c, tipo) => {
  const base = nuovoCampo(tipo);
  const n = { ...base, id: c.id, etichetta: c.etichetta || base.etichetta, descrizione: c.descrizione || '' };
  n.obbligatorio = SENZA_RISPOSTA.includes(tipo) ? false : SENZA_RISPOSTA.includes(c.tipo) ? base.obbligatorio : !!c.obbligatorio;
  // tra Regolamento e Testo da leggere il testo e le pagine restano
  if (['DOCUMENTO', 'INFO'].includes(tipo) && ['DOCUMENTO', 'INFO'].includes(c.tipo)) { n.testo_doc = c.testo_doc || ''; n.pagine_doc = [...(c.pagine_doc || [])]; if (c.etichetta) n.etichetta = c.etichetta; }
  // da Consenso a Regolamento la frase da spuntare diventa la conferma sotto il foglio
  if (tipo === 'DOCUMENTO' && c.tipo === 'CONSENSO' && c.etichetta) { n.testo_accetta = c.etichetta; n.etichetta = base.etichetta; }
  if (CON_OPZIONI.includes(tipo) && CON_OPZIONI.includes(c.tipo) && c.opzioni?.length) {
    n.opzioni = [...c.opzioni];
    if (tipo !== 'ELENCO' && c.note_opzioni) n.note_opzioni = [...c.note_opzioni];
    if (CON_FOTO.includes(tipo) && c.foto_opzioni) n.foto_opzioni = [...c.foto_opzioni];
  }
  if (c.anagrafica && ANAGRAFICA.some(a => a.chiave === c.anagrafica && a.tipo === tipo)) n.anagrafica = c.anagrafica;
  return n;
};

// Base pronta per un open day: anagrafica collegata, consenso privacy, codice identificativo.
export const MODELLO_OPEN_DAY = () => ({
  titolo: 'Iscrizione open day',
  descrizione: 'Compila il modulo per partecipare. Per i minorenni lo compila un genitore con i dati del ragazzo o della ragazza.',
  genera_codice: true, prefisso_codice: 'OD', collega_anagrafica: true,
  messaggio_conferma: 'Grazie! Conserva il tuo codice: ti servirà per seguire la tua iscrizione.',
  campi: [
    { id: nuovoId(), tipo: 'SEZIONE', etichetta: 'Dati del partecipante', descrizione: '', obbligatorio: false },
    { id: nuovoId(), tipo: 'TESTO_BREVE', etichetta: 'Nome', obbligatorio: true, anagrafica: 'nome' },
    { id: nuovoId(), tipo: 'TESTO_BREVE', etichetta: 'Cognome', obbligatorio: true, anagrafica: 'cognome' },
    { id: nuovoId(), tipo: 'DATA', etichetta: 'Data di nascita', obbligatorio: true, anagrafica: 'data_nascita' },
    { id: nuovoId(), tipo: 'TESTO_BREVE', etichetta: 'Luogo di nascita', descrizione: 'Comune, oppure lo stato se sei nato all\'estero.', obbligatorio: true, anagrafica: 'luogo_nascita' },
    { id: nuovoId(), tipo: 'CODICE_FISCALE', etichetta: 'Codice fiscale', obbligatorio: true, anagrafica: 'codice_fiscale' },
    { id: nuovoId(), tipo: 'EMAIL', etichetta: 'Email', descrizione: "Usa l'email con cui ti registrerai al portale.", obbligatorio: true, anagrafica: 'email' },
    { id: nuovoId(), tipo: 'TELEFONO', etichetta: 'Telefono', obbligatorio: true, anagrafica: 'telefono' },
    { id: nuovoId(), tipo: 'ELENCO', etichetta: 'Sede preferita', obbligatorio: false, opzioni: ['Sede 1', 'Sede 2'] },
    { id: nuovoId(), tipo: 'CONSENSO', etichetta: "Ho letto l'informativa privacy e acconsento al trattamento dei dati per l'iscrizione", obbligatorio: true },
  ],
});
